import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import {Link} from 'react-router-dom';
import lang from '../../constants/Languages.js';

const FooterBottomList = ({list, clang}) => {
    return (
        <div className="footer__bottom">
          <ul className="footer__bottom-list">
              {list.map((listItem, index) =>
                  <li key={index} className="footer__bottom-list__item">
                      {listItem.img && listItem.img.length &&
                          listItem.img.map((img, imgIndex) =>
                              <div key={imgIndex} className="footer__bottom-list__img-container">
                                  <img src={img} alt={lang[clang].alt.partners} className="footer__bottom-list__img"/>
                              </div>)}
                      {listItem.text &&
                          <div className="footer__bottom-list__text" dangerouslySetInnerHTML={{__html: listItem.text}}></div>}
                  </li>)}
            </ul>
        </div>
    );
};

FooterBottomList.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(FooterBottomList);



// WEBPACK FOOTER //
// ./src/components/footer/FooterBottomList.js